export default [
  {
    id: 1,
    path: '/home',
    name: '首页',
    component: resolve => require(['@/page/Home.vue'], resolve),
    meta: {
      title: '首页'
    }
  },
  {
    id: 3,
    path: '/advertisement',
    name: '广告中心',
    component: resolve => require(['@/page/advertisement/index.vue'], resolve),
    meta: {
      title: '广告中心'
    },
    children:[
      {
        id: 1,//屏蔽规则
        path: 'rule',
        component: resolve => require(['@/page/advertisement/rule.vue'], resolve),
        meta: {
          title: '屏蔽规则'
        },
      },
      {
        id: 2,//新建屏蔽规则
        path: 'addrule',
        component: resolve => require(['@/page/advertisement/addrule.vue'], resolve),
        meta: {
          title: '新建屏蔽规则'
        },
      },
    ]
  },

  {
    id: 4,
    path: '/dacenter',
    name: '数据中心',
    component: resolve => require(['@/page/dacenter/index.vue'], resolve),
    meta: {
      title: '数据中心'
    },
    children:[
      {
        id: 1,//广告数据
        path: 'adverdata',
        component: resolve => require(['@/page/dacenter/adverdata.vue'], resolve),
        meta:{
          title:'广告数据'
        }
      },
      {
        id: 5,//广告数据
        path: 'adverdata2',
        component: resolve => require(['@/page/dacenter/adverdata2.vue'], resolve),
        meta:{
          title:'广告数据'
        }
      },
      {
        id: 2,//广告数据
        path: 'partproduit',
        component: resolve => require(['@/page/dacenter/partProduit.vue'], resolve),
        meta:{
          title:'分成收益'
        }
      },
      {
        id: 3,//查看明细
        path: 'lookdetail',
        component: resolve => require(['@/page/dacenter/lookdetail.vue'], resolve),
        meta:{
          title:'查看明细'
        }
      },
    ]
  },

  {
    id:5,
    path: '/welfare',
    name: '福利中心',
    component: resolve => require(['@/page/welfare/index.vue'], resolve),
    meta: {
      title: '福利中心'
    },
    children: [
      {
        id:1,
        path: 'monitor',
        name: '应用监控',
        component: resolve => require(['@/page/welfare/monitor.vue'], resolve),
        meta: {
          title: '应用监控'
        }
      },
      {
        id: 2,
        path: '/tools/imgtools',
        name: '应用数据报表',
        component: resolve => require(['@/page/tools/imgtools.vue'], resolve),
        meta: {
          title: '应用数据报表'
        }
      },
      {
        id: 3,
        path: '/tools/imgtools',
        name: '广告位报表',
        component: resolve => require(['@/page/tools/imgtools.vue'], resolve),
        meta: {
          title: '广告位报表'
        }
      },
      {
        id: 4,
        path: '/tools/imgtools',
        name: '时段报表',
        component: resolve => require(['@/page/tools/imgtools.vue'], resolve),
        meta: {
          title: '时段报表'
        }
      },
      {
        id: 5,
        path: '/tools/imgtools',
        name: 'qps报表',
        component: resolve => require(['@/page/tools/imgtools.vue'], resolve),
        meta: {
          title: 'qps报表'
        }
      }
    ]
  },
  {
    id: 6,
    path: '/download',
    name: '下载中心',
    component: resolve => require(['@/page/download/index.vue'], resolve),
    meta: {
      title: '下载中心'
    },
    children: [
      {
        id: 1,
        path: 'sdk',
        name: 'SDK下载',
        component: resolve => require(['@/page/download/sdk.vue'], resolve),
        meta: {
          title: 'SDK下载'
        }
      },
      {
        id: 2,
        path: 'js',
        name: 'JS下载',
        component: resolve => require(['@/page/download/js.vue'], resolve),
        meta: {
          title: 'JS下载'
        }
      }
    ]
  },
  {
    id: 7,
    path: '/account',
    name: '账户管理',
    component: resolve => require(['@/page/account/index.vue'], resolve),
    meta: {
      title: '账户管理'
    },
    children:[
      {
        id:1,
        path:'user',
        name:'账户信息',
        component: resolve => require(['@/page/account/user.vue'], resolve),
        meta:{
          title:'账户信息'
        }
      },
      {
        id:2,
        path:'finance',
        name:'财务信息',
        component: resolve => require(['@/page/account/finance.vue'], resolve),
        meta:{
          title:'财务信息'
        }
      },
      {
        id:3,
        path:'myauthority',
        name:'我的权限',
        component: resolve => require(['@/page/account/myauthority.vue'], resolve),
        meta:{
          title:'我的权限'
        }
      },
      {
        id:4,
        path:'loginuserinfo',
        name:'登录用户信息',
        component:resolve => require(['@/page/account/loginuserinfo.vue'], resolve),
        meta:{
          title:'登录用户信息'
        }
      },
      {
        id:5,
        path:'editinfo',
        name:'修改用户信息',
        component:resolve => require(['@/page/account/editinfo.vue'], resolve),
        meta:{
          title:'修改用户信息'
        }
      },
    ]
  },
  {
    id: 8,
    path: '/message',
    name: '通知中心',
    component: resolve => require(['@/page/message/index.vue'], resolve),
    meta: {
      title: '通知中心'
    },
  },
  {
    id: 10,
    path: '/examine',
    name: '审核中心',
    component: resolve => require(['@/page/examine/index.vue'], resolve),
    meta: {
      title: '审核中心'
    },
    children:[
      {
        id: 1,
        path: 'media',
        name: '应用审核',
        component: resolve => require(['@/page/examine/media.vue'], resolve),
        meta: {
          title: '应用审核'
        },
      },
      {
        id: 2,
        path: 'addpos',
        name: '广告位审核',
        component: resolve => require(['@/page/examine/addpos.vue'], resolve),
        meta: {
          title: '广告位审核'
        },
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routers.js